
















































































import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import {
  DocuSignAdditionalDocumentSignTabModel,
  DocuSignAdditionalDocumentSignTabConfigurationModel,
  DocuSignAdditionalDocumentFileModel
} from '@/types';
import { RouteRegEx } from '@/types/enums';
import { DocuSignConfigurationService } from '@/services/docuSign/DocuSignConfigurationService';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper } from '@/mixins';
import Vue from 'vue';
export default Vue.extend({
  name: 'DocusignAdditionalDocumentSignTabManagement',
  mixins: [ComponentHelper, MTablehelper, RouteHelpers, confirmationHelper],
  data() {
    return {
      pageIsLoading: true,
      isLoading: false,
      fields: [
        {
          tabName: {
            label: 'Location',
            sortable: true
          }
        },
        {
          pageNumber: {
            label: 'Page Number',
            sortable: true
          }
        },
        {
          xCoord: {
            label: 'X Coordinate',
            sortable: true
          }
        },
        {
          yCoord: {
            label: 'Y Coordinate',
            sortable: true
          }
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ],
      items: [] as DocuSignAdditionalDocumentSignTabModel[],
      additionalDocument: {} as DocuSignAdditionalDocumentFileModel,
      hasError: false,
      errorMessage: '',
      tableStateKey: MTablehelper.Constants.TableStoreKeys.DocuSignAdditionalDocumentTabs
    };
  },
  methods: {
    getData(this: any) {
      return this.getAdditionalDocumentSignTabs(this.$route.params.id);
    },
    async getAdditionalDocumentSignTabs(this: any, id: number) {
      try {
        this.isLoading = true;
        // tslint:disable-next-line:max-line-length
        const additionalDocumentSignTabConfiguration = await DocuSignConfigurationService.getAdditionalDocumentSignTabsAsync(
          id
        );
        this.items = additionalDocumentSignTabConfiguration.signTabs;
        this.additionalDocument = additionalDocumentSignTabConfiguration.additionalDocumentFile;
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    navigateToEditSignTab(this: any, id: number) {
      const param = {} as { [index: string]: any };
      param.additionalDocumentId = this.additionalDocument.id;
      param.id = id;
      this.onTableStateFieldUpdated('selectedPk', id, this.tableStateKey);
      this.$router.push({
        name: 'docusignEditAdditionalDocumentSignTab',
        params: param
      });
    },
    navigateToId(this: any, routeName: any, data: any = null, paramName: string = 'id') {
      if (data) {
        const value = paramName === 'id' ? data : data.id;
      }
      this.navigateToRoute(routeName, data, paramName);
    },
    async deleteSignTab(this: any, id: number) {
      try {
        const result = await this.hasDeleteConfirmedAsync(this.$bvModal, 'Are you sure you want to delete the tab?');
        if (result) {
          this.isLoading = true;
          await DocuSignConfigurationService.deleteAdditionalDocumentsSignTabAsync(this.additionalDocument.id, id);
          SnotifyConfiguration.showSuccess('Additional document tab deleted successfully.');
          await this.getData();
        }
      } catch (error) {
        this.$log('failed to delete additional document tab', error);
      } finally {
        this.isLoading = false;
      }
    },
    resetViewState(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.DocuSignAdditionalDocumentTabs);
      if (!canKeepState) {
        this.resetMTableState(this.tableStateKey);
      }
    },
    async initialise(this: any) {
      try {
        this.pageIsLoading = true;
        this.resetViewState();
        await this.getData();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.pageIsLoading = false;
      }
    }
  },
  computed: {
    tableHeaderText(this: any) {
      return `Additional Document Sign Location Management (${this.additionalDocument.fileName})`;
    }
  },
  components: {
    MStoreTable,
    LoadingSpinner
  },
  mounted() {
    this.initialise();
  }
});
